import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { Button, Icon, Menu } from 'semantic-ui-react';
import ClientOption from 'src/container/Client/ClientOptions';

const Logo = require('img-loader!../assets/gtm-logo-black.png');

interface NavActions {
  push: any;
  closeMenu: any;
  authStore: any;
}

const LoggedOutView = ({push, closeMenu }: NavActions) => {
  return (
    <Button.Group size="large">
      <Button primary onClick={() => { push('/login'); closeMenu(); }}>
        <Icon name="sign in" /> sign in
      </Button>
      <Button.Or />
      <Button positive onClick={() => { push('/register'); closeMenu(); }}>
        <Icon name="signup" /> sign up
      </Button>
  </Button.Group>
  );
};

const LoggedInAccount = (props: any) => {
  return (
    <Menu.Item>
      Welcome <b> {props.currentUser}</b>,
    </Menu.Item>
  );
};

const LoggedInView = ({push, closeMenu }: NavActions) => {
  return (

    <Button.Group size="large">
      <Button  color="orange" onClick={() => { push('/settings'); closeMenu(); }}>
        <Icon name="user" /> Manage
      </Button>
      <Button.Or />
      <Button  color="grey" onClick={() => { push('/logout'); closeMenu(); }}>
        <Icon name="sign out"/> Logout
      </Button>
  </Button.Group>
  );
};

const SuperUserOptions = ({push, closeMenu, authStore }: NavActions) => {
  return [
    (
      <Menu.Item 
        key="unit"
        name="unit" 
        as={NavLink}
        onClick={(e: any) => {
          e.preventDefault();
          push('/unit');
          closeMenu();
        }}
        to="/unit"
        activeClassName="active"
      >
        <Icon name="microchip" />
        Unit
      </Menu.Item>
    ),
    (
      <Menu.Item 
        key="sensortype"
        name="sensortype" 
        as={NavLink}
        onClick={(e: any) => {
          e.preventDefault();
          push('/sensortype');
          closeMenu();
        }}
        to="/sensortype"
        activeClassName="active"
      >
        <Icon name="theme" />
        SensorType
      </Menu.Item>
    ),
    (
      <Menu.Item 
        key="client"
        name="client" 
        as={NavLink}
        onClick={(e: any) => {
          e.preventDefault();
          push('/client');
          closeMenu();
        }}
        to="/client"
        activeClassName="active"
      >
        <Icon name="world" />
        Clients
      </Menu.Item>
    ), 
    (
      <Menu.Item 
        key="clientOption"
        name="client" 
      >
        Select Current Client: 
        <ClientOption 
          name="selectedClient"
          value={authStore.clientId}
          onChange={currentClientChangeHandler.bind({ }, authStore)}
        />

      </Menu.Item>
    )
  ];
};

function currentClientChangeHandler(authStore: any, e: any, {name, value}: any) {
  authStore.setClient(value);
}

@inject('routing', 'commonStore', 'authStore')
@observer
class Header extends React.Component<any> {
  public render() {
    const { routing: { push }, authStore, commonStore } = this.props;

    const closeMenu = commonStore.closeMenu.bind(commonStore);

    const currentUser = typeof authStore.currentUser !== 'undefined' ?
      authStore.currentUser.name
      || authStore.currentUser.email
      : false;

    const isSuperUser = authStore.isSuperUser;
    const isGuest = authStore.isGuest;
    let navActions: NavActions =  { push, closeMenu, authStore };
    return (
      <Menu vertical fluid>
        <Menu.Item>
          <h1 className="title">
            <img 
              onClick={() => { push('/'); closeMenu(); }}
              src={Logo}
              className="clickable"
              height="54px"
              alt="GTM"
            />
          </h1>
        </Menu.Item>
        {currentUser &&
          <LoggedInAccount currentUser={currentUser} />}
        <Menu.Item>
          {currentUser && !isGuest
            ? <LoggedInView {...navActions}/>
            : <LoggedOutView {...navActions}/>}
        </Menu.Item>
        {currentUser ?
          <Menu.Item 
            name="dashboard" 
            as={NavLink}
            onClick={(e: any) => {
              e.preventDefault();
              push('/dashboard');
              closeMenu();
            }}
            to="/dashboard"
            activeClassName="active"
          >
            <Icon name="grid layout" />
            Dashboard
          </Menu.Item>
          : null
        }
        {currentUser ?
          <Menu.Item 
            name="chart" 
            as={NavLink}
            onClick={(e: any) => {
              e.preventDefault();
              push('/chart');
              closeMenu();
            }}
            to="/chart"
            activeClassName="active"
          >
            <Icon name="line chart" />
            Charts
          </Menu.Item>
          : null
        }
        {currentUser ?
          <Menu.Item 
            name="unitgroup" 
            as={NavLink}
            onClick={(e: any) => {
              e.preventDefault();
              push('/unitgroup');
              closeMenu();
            }}
            to="/unitgroup"
            activeClassName="active"
          >
            <Icon name="object group" />
            Unit Group
          </Menu.Item>
          : null
        }
        {currentUser ?
          <Menu.Item 
            name="unitsensor" 
            as={NavLink}
            onClick={(e: any) => {
              e.preventDefault();
              push('/unitsensor');
              closeMenu();
            }}
            to="/unitsensor"
            activeClassName="active"
          >
            <Icon name="thermometer half" />
            Unit Sensor
          </Menu.Item>
          : null
        }
        {isSuperUser ? 
          SuperUserOptions({...navActions})
          : null
        }
      </Menu>
    );
  }
}
export default Header;



// WEBPACK FOOTER //
// ./src/components/NavMenu.tsx